import * as React from 'react'
import {
  Filter,
  TextInput,
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
  ReferenceManyField,
  DateField,
} from 'react-admin'
import Chip from '@material-ui/core/Chip'
import { CountField } from '../components/Number'

const statusColors = {
  active: '#4caf50',
  deleted: '#f44336',
  blocked: '#ff9800',
}

const StatusBadge = ({ record }) => {
  if (!record?.status) return null
  const color = statusColors[record.status] || '#9e9e9e'
  return (
    <Chip
      label={record.status}
      size="small"
      style={{ backgroundColor: color, color: '#fff' }}
    />
  )
}
StatusBadge.defaultProps = { label: 'Status' }

const ParticipantFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
)

export const ParticipantList = (props) => (
  <List
    filters={<ParticipantFilter />}
    title="Gebruikers"
    {...props}
    sort={{ field: 'id', order: 'DESC' }}>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <DateField showTime source="created" label="Aangemeld" />
      <TextField source="firstName" label="Voornaam" />
      <TextField source="lastName" label="Achternaam" />
      <TextField source="email" label="E-mail" />
      <TextField source="city" label="Stad" />
      <TextField source="postalCode" label="Postcode" />
      <BooleanField source="newsletterActivities" label="Invites" />
      <ReferenceManyField
        label="Gevolgde sporten"
        reference="participant_activity"
        target="participantID"
        link={false}
        sortable={false}>
        <CountField field="id" />
      </ReferenceManyField>
      <TextField source="source" label="Type" />
      <StatusBadge source="status" />
      <EditButton />
    </Datagrid>
  </List>
)
